var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleanSterilizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#FDF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 20.8333C26.6668 25 23.7502 27.0833 20.2835 28.2916C20.102 28.3532 19.9048 28.3502 19.7252 28.2833C16.2502 27.0833 13.3335 25 13.3335 20.8333V15C13.3335 14.779 13.4213 14.567 13.5776 14.4107C13.7339 14.2544 13.9458 14.1666 14.1668 14.1666C15.8335 14.1666 17.9168 13.1666 19.3668 11.9C19.5434 11.7491 19.768 11.6663 20.0002 11.6663C20.2324 11.6663 20.457 11.7491 20.6335 11.9C22.0918 13.175 24.1668 14.1666 25.8335 14.1666C26.0545 14.1666 26.2665 14.2544 26.4228 14.4107C26.579 14.567 26.6668 14.779 26.6668 15V20.8333Z",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanSterilizeIcon);
export default __webpack_public_path__ + "static/media/clean_sterilize_icon.95dbe8d0936087f59e838f1a9e936191.svg";
export { ForwardRef as ReactComponent };